import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 引入自己配置的全局样式
import './assets/css/global.css'
// 引入样式及图标
import 'font-awesome/css/font-awesome.min.css';


import {
  getLanguageSessionStorage,
  setLanguageSessionStorage
} from '@/utils/storage.js'
// 挂载到Vue原型上（推荐加$前缀，区分内置属性）
Vue.prototype.$getLanguage = getLanguageSessionStorage
Vue.prototype.$setLanguage = setLanguageSessionStorage

// 全局语言变量 cn/en 
Vue.prototype.$language = getLanguageSessionStorage() || 'cn'

import cn_setting from '@/utils/setting_cn.json'
import en_setting from '@/utils/setting_en.json'


if (Vue.prototype.$language === 'en') {
  Vue.prototype.$commonSetting = en_setting;
  console.log(en_setting);
} else {
  Vue.prototype.$commonSetting = cn_setting;
  console.log(cn_setting);
}

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
